import Img from '../Img';
import s from './matchmakingEntry.module.scss';

const ICON =
  'https://cdn.duetapp.net/v1/images/eyJpZCI6Ik1PVU1QTTVQSFNZM01RRTNMVE8yUjdaSkpNWk5KUCIsInciOjU0LCJoIjo2MCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjgwMDM1ODA4NjQyODE2MDU2MX0';

export default function MatchmakingEntry({ compact }) {
  return (
    <a href="/matchmaking" className={compact ? `${s.entry} ${s.compact}` : s.entry} aria-label="Duet Matchmaking">
      <Img className={s.icon} src={ICON} alt="" />
      <span className={s.words}>
        <span className={s.name}>Duet</span>
        <span className={s.sub}>Matchmaking</span>
      </span>
    </a>
  );
}
